import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { LoggerService, shareReplayRefCount } from '@adreno-common';
import { CheckAgentTimeVm } from '../models';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TimeCheckService {
  private usersApi = `${environment.apiPath}/users`;

  constructor(private http: HttpClient, private logger: LoggerService) {}

  checkTimeAndOffset() {
    const now = new Date();
    const offset = 0 - now.getTimezoneOffset();
    const ticks = Math.round(now.getTime() / 1000); //we only want seconds
    return this.http
      .get<CheckAgentTimeVm>(
        `${this.usersApi}/time-check?offset=${offset}&ticks=${ticks}`
      )
      .pipe(shareReplayRefCount());
  }
}
